import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.define-property";

var _this = this;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _newArrowCheck(innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

export var HTMLUtils = function HTMLUtils() {
  _classCallCheck(this, HTMLUtils);
};
HTMLUtils.booleanAttrs = ["disabled", "hidden", "selected"];

HTMLUtils.isHTMLAttr = function (attribute, interfaces, noFilter) {
  var _this2 = this;

  _newArrowCheck(this, _this);

  return (interfaces ? interfaces : [Element]).reduce(function (acc, curr) {
    _newArrowCheck(this, _this2);

    return [].concat(_toConsumableArray(acc), _toConsumableArray(Object.keys(curr.prototype)));
  }.bind(this), []).filter(function (attr) {
    _newArrowCheck(this, _this2);

    return noFilter || !["id", "class"].includes(attr) && !attr.startsWith("aria");
  }.bind(this)) // filter attributes that shouldn't be passed through the dom
  .includes(attribute);
}.bind(this);
/**
 * CAUTION: This will only give you HTML attributes that are specified ON THE DOM ELEMENT.
 * Attributes that are set via prop will not be included.
 */


HTMLUtils.getHTMLAttrs = function (attrs, interfaces, options) {
  var _this3 = this;

  _newArrowCheck(this, _this);

  return (Array.isArray(attrs) ? attrs : Array.from(attrs)).filter(function (_ref) {
    var name = _ref.name;

    _newArrowCheck(this, _this3);

    if (options && options.omit) {
      return !options.omit.includes(name);
    }

    return HTMLUtils.isHTMLAttr(name, interfaces);
  }.bind(this)).reduce(function (acc, curr) {
    _newArrowCheck(this, _this3);

    return Object.assign(Object.assign({}, acc), _defineProperty({}, curr.name, curr.value === "" && HTMLUtils.booleanAttrs.includes(curr.name) ? true : curr.value));
  }.bind(this), {});
}.bind(this);